<form [formGroup]="form" (ngSubmit)="submit(model)">
  <formly-form [form]="form" [fields]="fields" [model]="model">
    <cap-button type="submit" label="Submit"></cap-button>
  </formly-form>
</form>
